import * as React from 'react';
import { getUserApi, logout, signUpEngineer } from '../api/api';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import RegistrationForm from '../features/registration/RegistrationForm';
import { useEffect } from 'react';
import { useUserStore } from '../stores/use-user-store';

// username === email - запрос от 28.05, чтобы не путать инженера
const EngineerRegistration = () => {
  const navigate = useNavigate();

  const { user, setUser, setAuthorized } = useUserStore();
  const [_res, _setRes] = React.useState({});
  const [searchParams] = useSearchParams();

  // разлогин в случае, если открыта текущая сессия:
  const signOut = async () => {
    await logout();
    setUser(null);
    setAuthorized(false);
  };

  useEffect(() => {
    const processSignOut = async () => {
      if (user) {
        await signOut();
      }
    };

    processSignOut();
  }, []);

  const handleSubmit = async (data) => {
    const { termsOfUse, personalData, ...fields } = data;

    const updatedFields = {
      ...fields,
      engineer: {
        ...fields.engineer,
        username: fields?.engineer?.email,
      },
    };
    const hash = searchParams.get('hash');
    const formData = { ...updatedFields, hash };

    if (!hash) {
      _setRes({ error: 'Пригласительная ссылка отсутствует' });
      return;
    }

    await signUpEngineer(
      formData,
      async function (data) {},
      function (err) {
        // ошибка на бэке неверная (временный костыль):
        if (err?.error === 'слишком короткий пароль' || err?.error.includes('небезопасный пароль')) {
          _setRes({ error: 'Небезопасный пароль. Уменьшите повторения символов' });
        } else {
          _setRes(err);
        }
      }
    );

    await getUserApi(
      function (data) {
        setUser(data);
        setAuthorized(true);
        navigate('/user');
      },
      function (err) {
        setAuthorized(false);
      }
    );
  };

  /** initial data: **/
  const inputsFields = [
    { name: 'engineer.fio', label: 'Фамилия, имя и отчество', placeholder: 'Укажите ФИО', type: 'text' },
    // { name: 'engineer.username', label: 'Логин', placeholder: 'someone@example.com', type: 'text' },
    {
      name: 'engineer.email',
      label: 'Введите email',
      placeholder: 'someone@example.com',
      type: 'email',
    },
    {
      name: 'engineer.phone',
      label: 'Номер телефона',
      placeholder: 'Введите номер телефона',
      mask: '+79999999999',
      type: 'text',
    },

    {
      name: 'engineer.password',
      label: 'Пароль',
      placeholder: 'Придумайте пароль',
      type: 'password',
    },
  ];

  return (
    <div className="flex w-full p-4 items-start justify-center bg-gradient-to-r from-[#ededed] to-[#dcdcdc]">
      <div className="rounded-3xl w-full max-w-lg pt-8 bg-white border-b border-x border-gray-300 overflow-hidden flex items-center flex-col">
        <img src={'logo.png'} alt="logo" className={'object-cover'} width={80} />
        <h1 className={'text-2xl text-center pt-4 font-medium text-gray-800'}>Регистрация инженера</h1>

        <RegistrationForm fields={inputsFields} handleSubmit={handleSubmit} error={_res?.error}>
          <span className={'text-gray-700 text-sm'}>
            Уже есть аккаунт?{' '}
            <Link className="text-orange-500 underline cursor-pointer text-start" to={'/'}>
              Войти
            </Link>
          </span>
        </RegistrationForm>
      </div>
    </div>
  );
};

export default EngineerRegistration;
